export const ipToInt = (ip: string): number => {
  return ip
    .split(".")
    .reduce((acc, octet) => (acc << 8) + parseInt(octet, 10), 0);
};

/**
 * Browser-side twins of the checks in `functions/helper/ip.ts` - keep them in sync.
 * The server-side copies are the authoritative gate (they decide whether a
 * questionnaire may be bootstrapped); these exist because UI code cannot import from
 * `functions/` (outside the CRA `src` root).
 *
 * They live in this leaf module, not in a barrel: `helper/parser/opsanio.ts` is also
 * loaded by server code and by the node:test harness, so importing values through
 * `src/questionnaires` or `src/index.tsx` would drag the React app graph into those
 * runtimes.
 */
export const isValidCIDR = (cidr: string) => {
  const cidrRegex =
    /^((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9]?[0-9])\.){3}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9]?[0-9])\/(3[0-2]|[12]?[0-9])$/;
  return cidrRegex.test(cidr);
};

/**
 * 1 through 4094 are usable VLAN ids - VLAN 1 included: it is the default/native VLAN
 * and a customer LAN sitting untagged on it is normal. Only 0 and 4095 are reserved.
 * Non-integers (an unanswered fact parsed to NaN) are invalid.
 */
export const isValidVlan = (vlan: number) => {
  const id = Number(vlan);
  return Number.isInteger(id) && id >= 1 && id <= 4094;
};
